module.exports = __webpack_public_path__ + "static/media/DSCF1771-2.49300e82.jpg";